import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';

import { withFirebase } from '../../firebase';

import UserProfileModal from '../modals/UserProfile';

import phoneIcon from '../../assets/iphone_icon.svg';
import mailIcon from '../../assets/email_icon.svg';
import locationIcon from '../../assets/location_icon.svg';

import { toggleSidebar } from '../../actions/sidebarActions';

import formatPhoneNumber from '../../util/phoneNumber';

import { userRoles } from '../../constants';

import './dashboard.scss';

const DashboardHeader = (props) => {
  const { user, toggleSidebar } = props;

  const [isOpen, toggleModal] = useState(user && !!user.adminPassword);

  const displayUserRole = (role) => userRoles[role] && userRoles[role].label;

  return (
    <Paper className="dashboard-header">
      <div className="image-container">
        {/* Mobile menu icon */}
        <Box sx={{ display: { sm: 'none' } }}>
          <div className="menu-icon-container">
            <IconButton
              edge="start"
              color="primary"
              aria-label="menu"
              onClick={toggleSidebar}
            >
              <MenuIcon />
            </IconButton>
          </div>
        </Box>

        <img src="dashboard-header.png" alt="dashboard-header" />

        {/* Desktop user name */}
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
          <div className="dashboard-user-name">
            <div>
              {user.firstName &&
                user.lastName &&
                `${user.role === userRoles.SURGEON.name ? 'Dr. ' : ''}${user.firstName} ${user.lastName}`}
            </div>
            <div>{displayUserRole(user.role)}</div>
          </div>
        </Box>

        {/* Desktop avatar */}
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
          <div className="dashboard-avatar-container">
            <img
              src={user && user.photoUrl ? user.photoUrl : 'default_user.svg'}
              alt="avatar"
            />
          </div>
        </Box>

        {/* Mobile avatar */}
        <Box sx={{ display: { sm: 'none' } }}>
          <div className="dashboard-avatar-container-mobile">
            <img
              src={user && user.photoUrl ? user.photoUrl : 'default_user.svg'}
              alt="avatar"
            />
          </div>
        </Box>
      </div>

      <div className="dashboard-header-info">
        {/* Desktop-only info */}
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
          {user.phone && (
            <div className="user-info-item">
              <img src={phoneIcon} alt="phone-icon" />
              {formatPhoneNumber(user.phone)}
            </div>
          )}

          <div className="user-info-item">
            <img src={mailIcon} alt="mail-icon" />
            {user.email}
          </div>

          {user.address && (
            <div className="user-info-item">
              <img src={locationIcon} alt="location-icon" />
              {user.address}
            </div>
          )}

          <div className="edit-link" onClick={() => toggleModal(true)}>
            Edit
          </div>
        </Box>
      </div>

      <UserProfileModal
        open={isOpen}
        onClose={() => toggleModal(false)}
        userFirstName={user ? user.firstName : ''}
        userLastName={user ? user.lastName : ''}
        userAddress={user ? user.address : ''}
        userPhone={user ? user.phone : ''}
        adminPassword={!!user.adminPassword}
        currentUser={user}
      />
    </Paper>
  );
};

DashboardHeader.propTypes = {
  user: PropTypes.object,
  toggleSidebar: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    user: state.user.currentUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleSidebar: () => dispatch(toggleSidebar()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withFirebase(DashboardHeader));
